import React from "react";
import { PIPELINE_STAGE_IDS } from "../constants/pipelineStages";
import PipelineCard from "./PipelineCard";

/**
 * @param {Object} props
 * @param {{ id: string, label: string, dotClass: string }} props.stage
 * @param {import('../hooks/usePipelineBoard').PipelineCardModel[]} props.cards
 * @param {(cardId: string) => void} props.onAdvanceCard
 * @param {(cardId: string) => void} [props.onPrimaryAction]
 * @param {(cardId: string) => void} [props.onMore]
 * @param {(cardId: string) => void} [props.onOpenCard]
 * @param {() => void} [props.onAddInfluencer]
 */
function PipelineColumn({
  stage,
  cards,
  onAdvanceCard,
  onPrimaryAction,
  onMore,
  onOpenCard,
  onAddInfluencer,
}) {
  return (
    <div className="flex flex-col w-[280px] sm:w-[340px] shrink-0 min-h-[320px]">
      {/* Lane header block */}
      <div className="px-2 py-1.5 rounded-t-xl bg-white border border-[#E3DFD9] border-b-0 shadow-[0_1px_0_rgba(0,0,0,0.02)]">
        <div className="flex items-center gap-2">
          <span
            className={`w-2 h-2 rounded-full shrink-0 ${stage.dotClass}`}
            aria-hidden
          />
          <h2 className="text-xs sm:text-[13px] font-semibold text-[#1A1714] tracking-wide">
            {stage.label}
          </h2>
          <span className="ml-auto inline-flex items-center justify-center rounded-full bg-[#F4F2EF] px-2 py-0.5 text-[10px] font-semibold text-[#6B6560] border border-[#E3DFD9] tabular-nums">
            {cards.length}
          </span>
        </div>
        {stage.desc && (
          <p className="mt-1.5 text-[10px] text-[#A09890]">
            {stage.desc}
          </p>
        )}
      </div>

      <div className="flex-1 flex flex-col gap-3 rounded-b-2xl bg-[#F0EDE9] border border-[#E3DFD9] border-t-0 p-2.5 min-h-[260px] shadow-[0_0_0_1px_rgba(227,223,217,0.9)]">
        {cards.map((card) => (
          <PipelineCard
            key={card.id}
            card={card}
            onAdvance={onAdvanceCard}
            onPrimaryAction={onPrimaryAction}
            onMore={onMore}
            onOpen={onOpenCard}
          />
        ))}
        {onAddInfluencer && stage.id === PIPELINE_STAGE_IDS.SHORTLISTED && (
          <button
            type="button"
            onClick={onAddInfluencer}
            className="mt-2 w-full py-2.5 rounded-lg border border-dashed border-[#E3DFD9] text-[11px] font-semibold text-[#6B6560] hover:border-[#E65C1A] hover:text-[#E65C1A] hover:bg-[#FFF0E8] transition-colors bg-white"
          >
            + Add influencer
          </button>
        )}
      </div>

      
    </div>
  );
}

export default PipelineColumn;
